import { render, staticRenderFns } from "./ExcelRequests.vue?vue&type=template&id=ffb8dc54&scoped=true&"
import script from "./ExcelRequests.vue?vue&type=script&lang=js&"
export * from "./ExcelRequests.vue?vue&type=script&lang=js&"
import style0 from "./ExcelRequests.vue?vue&type=style&index=0&id=ffb8dc54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb8dc54",
  null
  
)

export default component.exports